import React from 'react';

import { Routes, Route } from 'react-router-dom';

import { PageError } from '../../../layout';
import { AuthById } from '../AuthById';
import { AuthList } from '../AuthList';

import { Login } from './Login';
import { Register } from './Register';
import { VerifyAuthCode } from './VerifyAuthCode';

export const OAuth2 = () => {
  return (
    <Routes>
      <Route path="login" element={<Login />} />
      <Route path="register" element={<Register />} />
      <Route path="result" element={<VerifyAuthCode />} />
      <Route path="auth-list" element={<AuthList />} />
      <Route path=":id/*" element={<AuthById />} />
      <Route
        path="*"
        element={
          <div>
            <PageError status={404} />
          </div>
        }
      />
    </Routes>
  );
};
